import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const GET_SESSION_WITH_PROVIDER: UrlConstant = { path: '/sessions/getSessionWithProvider', method: HttpMethod.POST };
export const CREATE_SESSION_WITH_PROVIDER: UrlConstant = { path: '/sessions/createSessionWithProvider', method: HttpMethod.POST };
